import { render } from "./Create.vue?vue&type=template&id=48ac144e&scoped=true"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"

import "./Create.vue?vue&type=style&index=0&id=48ac144e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-48ac144e"

export default script